<template>
  <div class="area-date-picker">
    <div class="area-date-picker__title" @click="toggleOpenState('header')"
         :class="{'area-date-picker__title_selected': isSelected}">{{title}}
      <div class="area-date-picker__arrow"/>
    </div>
    <div class="area-date-picker__overlay"
         v-show="isOpened" @click.stop="toggleOpenState('overlay')"></div>
    <div class="area-date-picker__dropdown" v-show="isOpened" @click.stop="()=>{}">
      <base-date-range-filter-dropdown
        :columns="columns"
        ref="picker"
        :dates="dates"
        :useFields="useFields"
        v-model="isSelected"
        @apply="applyFilters($event)"
        @close="close()"
        :from-page="fromPage"
      />
<!--      <div class="area-date-picker__footer" @click.stop="()=>{}">-->

<!--        <button class="area-date-picker__button area-date-picker__button-footer area-date-picker__button-footer_apply"-->
<!--                :class="{'area-date-picker__button-with-fields': useFields}"-->
<!--                @click.stop="apply()">-->
<!--          Apply-->
<!--        </button>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import AreaChart from '../features/reports/common/AreaChart'

/**
 * Date Picker for Chart. Used in {@link AreaChart}
 */
export default {
  name: 'AreaChartDatePicker',
  props: {
    restrictions: {
      type: Array,
      default: () => []
    },
    columns: {
      default: 1
    },
    dates: {
      type: Array,
      default: () => []
    },
    useFields: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      range: {},
      isOpened: false,
      isSelected: false
    }
  },
  methods: {
    applyFilters (event) {
      this.range = event
      this.$emit('apply', this.range)
      this.close()
    },
    toggleOpenState (source) {
      this.isOpened = !this.isOpened
      this.$refs.picker.closeViaOverlay()
      this.$emit('state', this.isOpened)
    },
    close () {
      this.isOpened = false
    }
    // apply () {
    //   this.$refs['picker'].apply()
    // }
  },
  computed: {
    minDate () {
      return this.restrictions.length ? this.restrictions[0] : null
    },
    maxDate () {
      return this.restrictions.length ? this.restrictions[1] : null
    },
    fromPage () {
      if (this.minDate) {
        return {
          month: parseInt(moment(this.minDate).subtract(1, 'months').format('M')),
          year: parseInt(moment(this.minDate).subtract(1, 'months').format('YYYY'))
        }
      } else {
        return null
      }
    },
    title () {
      const start = _.get(this.range, 'date_from', '')
      const end = _.get(this.range, 'date_to', '')
      if (start && end) {
        return `${moment(start).format('MMM DD-YYYY')} - ${moment(end).format('MMM DD-YYYY')}`
      }
      return 'Choose date'
    }
  }

}
</script>

<style scoped lang="scss">
  .area-date-picker {
    &__title {
      display: flex;
      padding: 5px 10px;
      border: 1px solid $rfx-light-steel;
      border-radius: 4px;
      align-items: center;
      font-size: 12px;
      color: $rfx-medium-march;
      height: 40px;
      box-sizing: border-box;
      justify-content: space-between;
      min-width: 200px;
      font-weight: 500;
      cursor: pointer;
      white-space: nowrap;
      background-color: white;

      &_selected {
        background-color: $rfx-light-grey;
      }
    }

    &__overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      padding: 0;
      background: transparent;
    }

    &__dropdown {
      border-top: 2px solid $rfx-bright-blue;
      top: 100%;
      background-color: #fff;
      box-shadow: 0 0 1px 0 rgba(8, 8, 8, .24), 0 4px 15px 0 rgba(8, 8, 8, .24);
      cursor: auto;
      border-radius: 0 0 6px 6px;
      padding: 5px;
      z-index: 999;
    }

    &__arrow {
      flex: 0 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-bottom: 3px;

      &::after {
        content: '';
        display: block;
        width: 7px;
        height: 7px;
        box-sizing: border-box;
        border-right: 2px solid $rfx-bright-blue;
        border-bottom: 2px solid $rfx-bright-blue;
        transform: rotate(45deg);
        transform-origin: center;
      }
    }

    &__footer {
      display: flex;
      margin: 10px;
      justify-content: flex-end;
      z-index: 9999;
    }

    &__button {
      border: none;
      outline: none;
      cursor: pointer;
      font-size: 10px;
      z-index: 999;

      &-with-fields {
        position: absolute;
        top: 138px;
        right: 6px;
      }
    }

    &__button-footer {
      padding: 7px 10px;
      border-radius: 4px;

      &_apply {
        background-color: $rfx-medium-march;
        color: #fff;

        &:disabled {
          pointer-events: none;
          background-color: #fff;
          color: $rfx-neutral-grey;
          cursor: default;
        }
      }

      &_disabled {
        pointer-events: none;
        background-color: #fff;
        color: $rfx-neutral-grey;
        cursor: default;
      }

      &_cancel {
        color: $rfx-dark-march;
        background-color: #fff;
        margin-right: 10px;
      }
    }

  }
</style>
